import React, { useEffect, useState } from "react";

export default function Les4() {
  const [Count, setCount] = useState(0);
  useEffect(() => {
    document.title = `Title4 ${Count}`;
  }, [Count]);
  return (
    <div>
      <button
        onClick={(e) => {
          e.preventDefault();
          setCount(Count + 1);
        }}
      >
        Plus
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// src/page/les4.js